<button style="margin: 0 2px" mat-mini-fab color="inherit" aria-label="Notifications"
  class="d-flex justify-content-center" [matTooltip]="'NOTIFICATIONS.TITLE' | translate" (click)="openPanel()"
  #notificationsOrigin>
  <span [matBadge]="unReadedNotificationCount" matBadgeSize="small" [matBadgeHidden]="unReadedNotificationCount === 0"
    matBadgeColor="warn">
    <i class="iconify icon-22 d-flex" data-icon="solar:bell-outline"></i>
  </span>
</button>


<ng-template #notificationsPanel>
  <div class="notif-panel">

    <!-- Header -->
    <div class="notif-header">
      <div class="notif-header-left">
        <button mat-icon-button class="notif-close-btn" (click)="closePanel()">
          <mat-icon>close</mat-icon>
        </button>
        <mat-icon class="notif-header-icon">notifications</mat-icon>
        <h3 class="notif-header-title">{{ 'NOTIFICATIONS.TITLE' | translate }}</h3>
      </div>
      <div class="notif-header-right">
        @if (unReadedNotificationCount > 0) {
        <span class="notif-unread-badge">{{ unReadedNotificationCount }}</span>
        }
        <button mat-icon-button [matTooltip]="'NOTIFICATIONS.MARK_ALL_READ' | translate"
          [disabled]="unReadedNotificationCount === 0" (click)="markAllAsRead()">
          <mat-icon>done_all</mat-icon>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="notif-content">
      @for (notification of notificationArr; track notification.id || $index) {
      <div class="notif-item" [class.notif-unread]="!notification.isReaded"
        (click)="onNotificationClicked(notification)">
        <!-- Icon -->
        <div class="notif-item-icon" [class.notif-item-icon-unread]="!notification.isReaded">
          <mat-icon>{{ notification?.notificationType?.icon || 'notifications' }}</mat-icon>
        </div>

        <!-- Info -->
        <div class="notif-item-body">
          <div class="notif-item-header-row">
            @if (notification?.notificationType?.name) {
            <span class="notif-item-type">{{ notification?.notificationType?.name }}</span>
            }
            @if (!notification.isReaded) {
            <span class="notif-new-dot"></span>
            }
          </div>

          @if (notification.message) {
          <p class="notif-item-message">{{ notification.message }}</p>
          }

          @if (notification.requestValue) {
          <span class="notif-item-extra">
            {{ 'NOTIFICATIONS.PERIOD' | translate }}: {{ notification.requestValue }} {{ 'NOTIFICATIONS.MIN' | translate
            }}
          </span>
          }

          <!-- Approval status badges -->
          @if (notification.notificationType?.code === constant.notificationTypes.SHIFT_EXTENSION_APPROVAL
          || notification.notificationType?.code === constant.notificationTypes.SHIFT_EXTENSION_REQUESTER) {
          @if (notification?.isApproved === true) {
          <span class="notif-status-badge notif-status-accepted">
            <mat-icon>check_circle</mat-icon>
            {{ 'NOTIFICATIONS.ACCEPTED' | translate }}
          </span>
          }
          @if (notification?.isApproved === false) {
          <span class="notif-status-badge notif-status-denied">
            <mat-icon>cancel</mat-icon>
            {{ 'NOTIFICATIONS.CANCELED' | translate }}
          </span>
          }
          }

          <span class="notif-item-date">{{ notification.notificationDate }}</span>
        </div>

        <!-- Actions -->
        <div class="notif-item-actions">
          <!-- Transfer actions -->
          @if (notification?.notificationType?.hasAction && notification.notificationType.code ===
          constant.notificationTypes.TRANSFER) {
          @if (notification?.isApproved === null) {
          <div class="notif-action-buttons">
            <button mat-icon-button class="notif-btn-accept" [matTooltip]="'ORDER_RETURN.ACCEPT' | translate"
              (click)="acceptTransfer($event, notification.targetId)">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button class="notif-btn-reject" [matTooltip]="'ORDER_RETURN.CANCEL' | translate"
              (click)="cancelTransfer($event, notification.targetId)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          }
          }

          <!-- Approval actions -->
          @if (notification?.notificationType?.hasAction && notification.notificationType.code !==
          constant.notificationTypes.TRANSFER) {
          @if (notification?.isApproved === null) {
          <div class="notif-action-buttons">
            <button mat-icon-button class="notif-btn-accept" [matTooltip]="'ORDER_RETURN.ACCEPT' | translate"
              (click)="accept($event, notification.targetId)">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button class="notif-btn-reject" [matTooltip]="'ORDER_RETURN.CANCEL' | translate"
              (click)="cancel($event, notification.targetId)">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          }
          }

          <!-- Read/Delete controls -->
          <div class="notif-meta-actions">
            <button mat-icon-button class="notif-toggle-read"
              (click)="toggleRead(notification); $event.stopPropagation()"
              [matTooltip]="(notification.isReaded ? 'NOTIFICATIONS.MARK_UNREAD' : 'NOTIFICATIONS.MARK_READ') | translate">
              <div class="notif-read-dot" [class.is-read]="notification.isReaded"
                [class.is-unread]="!notification.isReaded"></div>
            </button>
            <button mat-icon-button class="notif-delete-btn" (click)="delete(notification); $event.stopPropagation()"
              [matTooltip]="'NOTIFICATIONS.DELETE' | translate">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>
      </div>
      }

      <!-- Empty state -->
      @if (!notificationArr || notificationArr.length === 0) {
      <div class="notif-empty">
        <div class="notif-empty-icon">
          <mat-icon>notifications_off</mat-icon>
        </div>
        <p class="notif-empty-title">{{ 'COMMON.NO_NOTIFICATIONS' | translate }}</p>
        <p class="notif-empty-desc">{{ 'COMMON.NO_NOTIFICATIONS_DESC' | translate }}</p>
      </div>
      }
    </div>
  </div>
</ng-template>